export function isLeapYear(year: number) {
  return year % 400 == 0 || (year % 100 != 0 && year % 4 == 0);
}

export function getMonthLength(year: number, month: number) {
  const monthLengths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  if (isLeapYear(year)) {
    monthLengths[1] = 29;
  }

  return monthLengths[month];
}

const daysInYear = 365.25;

export const differenceInYears = (left: Date, right: Date): number => {
  const diffSeconds = (right.getTime() - left.getTime()) / 1000;
  const diffDays = diffSeconds / (60 * 60 * 24);

  return Number((diffDays / daysInYear).toFixed(3));
};
